var map = {
	"./assets/clickable/paypal.svg": "3f222e135c8e553614c8",
	"./assets/disabled/paypal.svg": "bab44a7482b34d3d30f0",
	"./assets/original/paypal.svg": "bc3bee2370ca816b7526"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87ef017dd7d2d0ef4d8f";